
import { httpservice } from '../services';
import { constants } from '../constant/constant';
import {ENTITY} from '../constant';
import {httpserviceWithMultipart} from "../services/HttpServices";
import {THIRD_EMOTION} from '../constant/actionTypes';
let apiEndPoint = constants.ADMIN_URL;

export const doThirdEmotionCreate = data => {
    return httpserviceWithMultipart('post', data, `${apiEndPoint}${constants.API.THIRD_EMOTION}`)
        .then( (response) => {
            console.log(response)

            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });

};

export const doThirdEmotionDelete = Id => {
    const endPointUri = constants.API.THIRD_EMOTION_BY_ID.replace(ENTITY.THIRD_EMOTION_ID, Id);
    return httpservice()
        .delete(endPointUri)
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};

export const doThirdEmotionUpdate = (Id, data) => {
    const endPointUri = constants.API.THIRD_EMOTION_BY_ID.replace(ENTITY.THIRD_EMOTION_ID, Id);
    
    return httpserviceWithMultipart('put', data, `${apiEndPoint}${endPointUri}` )
        .then(function (response) {
            return {status:1,data:response.data};
        })
        .catch(function (error) {
            return {status:0,data:error.response && error.response.data ? error.response.data : error};
        });
};
